import { number, object } from '@/core/utils/validation';
import { stockInvoiceSchema } from './SocketMessageBase.yup';
const schema = object({
    stockReceiptItem: object({
        stockReceiptItemId: number().id(),
        quantity: number().integer().positive().required(),
        receiptedQuantity: number().integer().min(0).required(),
    }).required(),
    stockInvoice: stockInvoiceSchema.required(),
}).noUnknown(true);
export { schema as placedToStockMessageSchema };
